export default __webpack_public_path__ + "static/media/img33.9a53449c.jpg";